import { SHOW_SELECTED_URL_PARAM } from '@/config/constants';
import { FILTER_KEYS, NEW_DATA_URL_PARAM } from '../constants';
import type { FilterState } from '../types/filter.types';

const parseAsBoolean = (value: string | null) => value === 'true';

export function extractFiltersFromParams(searchParams: URLSearchParams): FilterState {
  return {
    only: searchParams.get('only'),
    [SHOW_SELECTED_URL_PARAM]: parseAsBoolean(searchParams.get(SHOW_SELECTED_URL_PARAM)),
    [NEW_DATA_URL_PARAM]: parseAsBoolean(searchParams.get(NEW_DATA_URL_PARAM)),
    search: searchParams.get('search'),
    [FILTER_KEYS.COMMODITY]: searchParams.getAll(FILTER_KEYS.COMMODITY),
    [FILTER_KEYS.TRADING_HUB]: searchParams.getAll(FILTER_KEYS.TRADING_HUB),
    [FILTER_KEYS.DELIVERY_BASIS]: searchParams.getAll(FILTER_KEYS.DELIVERY_BASIS),
    [FILTER_KEYS.PRICING_BASIS]: searchParams.getAll(FILTER_KEYS.PRICING_BASIS),
    [FILTER_KEYS.UNITS]: searchParams.getAll(FILTER_KEYS.UNITS),
    [FILTER_KEYS.CURRENCY]: searchParams.getAll(FILTER_KEYS.CURRENCY),
    [FILTER_KEYS.FREQUENCY]: searchParams.getAll(FILTER_KEYS.FREQUENCY),
    [FILTER_KEYS.INDEX_MODULE]: searchParams.getAll(FILTER_KEYS.INDEX_MODULE)
  };
}
